import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { CommonPipesModule, UIKitModule } from '@vendasta/uikit';
import baseTranslation from './assets/i18n/en_devel.json';
import { CheckReviewDeletedPipe } from './common-review-card/check-review-deleted.pipe';
import { CommentFromNowPipe } from './common-review-card/comment-from-now.pipe';
import { ReviewCardComponent } from './common-review-card/common-review-card.component';
import { ConnectAccountDialogComponent } from './common-review-card/connect-account-dialog.component';
import { NotRecommendedIconComponent } from './common-review-card/not-recommended-icon.component';
import { RecommendedIconComponent } from './common-review-card/recommended-icon.component';
import { ReviewsService } from './common-review-card/review-card.service';
import { ReviewHistoryCardComponent } from './common-review-card/review-history-card/review-history-card.component';
import { TransformReviewContentPipe } from './common-review-card/transform-review-content.pipe';
import { WEBLATE_COMPONENT_NAME } from './constants';
import { FilterTemplatesPipe } from './response-templates/filter-templates.pipe';
import { PaginateTemplatesPipe } from './response-templates/paginate-templates.pipe';
import { RandomizeTemplatesPipe } from './response-templates/randomize-templates.pipe';
import { ReviewCardResponseTemplatesService } from './response-templates/response-templates.service';
import { ValidateResponsePipe } from './response-templates/validate-response.pipe';

const MaterialModules = [
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatIconModule,
  MatTabsModule,
  MatDialogModule,
  MatMenuModule,
  MatChipsModule,
  MatFormFieldModule,
  MatInputModule,
  MatSnackBarModule,
  MatListModule,
  MatSelectModule,
  MatTooltipModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
];

@NgModule({
  declarations: [
    ReviewCardComponent,
    FilterTemplatesPipe,
    ValidateResponsePipe,
    RandomizeTemplatesPipe,
    PaginateTemplatesPipe,
    CheckReviewDeletedPipe,
    CommentFromNowPipe,
    TransformReviewContentPipe,
    ConnectAccountDialogComponent,
    RecommendedIconComponent,
    NotRecommendedIconComponent,
    ReviewHistoryCardComponent,
  ],
  imports: [
    UIKitModule,
    MaterialModules,
    GalaxyButtonLoadingIndicatorModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    CommonModule,
    CommonPipesModule,
    ClipboardModule,
    GalaxyFormFieldModule,
    GalaxyLoadingSpinnerModule,
    GalaxyBadgeModule,
    GalaxyEmptyStateModule,
    GalaxyPipesModule,
  ],
  exports: [
    ReviewCardComponent,
    FilterTemplatesPipe,
    ValidateResponsePipe,
    RandomizeTemplatesPipe,
    PaginateTemplatesPipe,
  ],
  providers: [ReviewCardResponseTemplatesService, ReviewsService],
})
export class CommonReviewCardModule {}
